import { render } from "./ImageCell.vue?vue&type=template&id=28a47ad2&scoped=true"
import script from "./ImageCell.vue?vue&type=script&lang=js"
export * from "./ImageCell.vue?vue&type=script&lang=js"

import "./ImageCell.vue?vue&type=style&index=0&id=28a47ad2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a47ad2"]])

export default __exports__